export default "__VITE_ASSET__BXymPzYX__"